import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from '../../api/resources.js';
import { Button } from '../../components/ui/button.js';
import { Field, Input } from '../../components/ui/input.js';
import { useAction } from '../../lib/hooks.js';
import { AuthError, AuthLayout } from './layout.js';

/** Esqueci a senha: sempre a mesma resposta, exista a conta ou não (§68). */
export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const submit = useAction(async () => {
    await auth.forgotPassword(email);
    setSent(true);
  });

  return (
    <AuthLayout
      title="Redefinir senha"
      description={
        sent
          ? undefined
          : 'Informe o e-mail da conta. Se ele existir, enviamos um link válido por 30 minutos.'
      }
      footer={<Link to="/login">Voltar para o login</Link>}
    >
      {sent ? (
        <p className="m-0 text-sm" role="status">
          Se existir uma conta para <strong>{email}</strong>, o link de redefinição já está a
          caminho. Confira também a caixa de spam.
        </p>
      ) : (
        <form
          onSubmit={(event) => {
            event.preventDefault();
            void submit.run();
          }}
        >
          <AuthError error={submit.error} />
          <Field label="E-mail" htmlFor="email">
            <Input
              id="email"
              type="email"
              required
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </Field>
          <Button className="w-full" type="submit" disabled={submit.pending}>
            {submit.pending ? 'Enviando…' : 'Enviar link'}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}

/** A nova senha, com o token do link. Uso único; depois, login normal. */
export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [mismatch, setMismatch] = useState(false);

  const submit = useAction(async () => {
    if (password !== confirm) {
      setMismatch(true);
      return;
    }
    setMismatch(false);
    await auth.resetPassword(token, password);
    navigate('/login?reset=1', { replace: true });
  });

  if (!token) {
    return (
      <AuthLayout title="Link inválido" footer={<Link to="/forgot">Pedir um novo link</Link>}>
        <p className="m-0 text-sm">Este link não tem um token de redefinição.</p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Nova senha" description="Mínimo de 12 caracteres, com letras e números.">
      <form
        onSubmit={(event) => {
          event.preventDefault();
          void submit.run();
        }}
      >
        <AuthError error={submit.error} />
        <Field label="Nova senha" htmlFor="password">
          <Input
            id="password"
            type="password"
            required
            minLength={12}
            autoComplete="new-password"
            autoFocus
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </Field>
        <Field
          label="Confirme a senha"
          htmlFor="confirm"
          {...(mismatch ? { hint: 'As senhas não conferem.' } : {})}
        >
          <Input
            id="confirm"
            type="password"
            required
            minLength={12}
            autoComplete="new-password"
            value={confirm}
            onChange={(event) => setConfirm(event.target.value)}
            aria-invalid={mismatch ? true : undefined}
          />
        </Field>
        <Button className="w-full" type="submit" disabled={submit.pending}>
          {submit.pending ? 'Salvando…' : 'Salvar nova senha'}
        </Button>
      </form>
    </AuthLayout>
  );
}
